export const getDifferenceColor = (difference, theme) => {
    if (difference > 0) {
        return theme.mercado.up;
    }
    return theme.mercado.down;
};

export const getValorDeMercadoColor = (valorDeMercado, theme) => {
    if (!valorDeMercado) {
        return theme.mercado.default;
    } else {
        const valorDeMercadoNumber = Number(valorDeMercado);
        if (valorDeMercadoNumber > 0) {
            return theme.mercado.up;
        } else if (valorDeMercadoNumber < 0) {
            return theme.mercado.down;
        }
        return theme.mercado.default;
    }
};
